import { type FC, useEffect } from "react";
import { Button } from "../../components/ui/button";
import { Activity } from "lucide-react";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const ThankYouPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionData = SessionStorageHelper.getAllData();
    // Assessment completion status checked
  }, []);

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 p-4">
          {/* Logo */}
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-orange-400">
              <Activity className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-muted-foreground">
              Bite Balance
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col items-center justify-center px-4 py-4 text-center sm:px-6">
          {/* Activity Icon */}
          <div className="mb-6 sm:mb-8">
            <Activity
              className="mx-auto h-12 w-12 text-primary sm:h-16 sm:w-16"
              strokeWidth={2}
            />
          </div>

          {/* Text Content */}
          <div className="space-y-1">
            <h1 className="text-3xl font-bold text-foreground sm:text-4xl">
              Thank You
            </h1>
            <p className="text-base text-foreground sm:text-lg">
              For Trusting Us
            </p>
          </div>

          <p className="mx-auto max-w-xs pt-3 text-xs leading-relaxed text-muted-foreground sm:pt-4 sm:text-sm">
            We promise to always keep your personal information private and
            secure.
          </p>
        </div>

        {/* Footer Button */}
        <div className="pb-safe p-4">
          <Button
            onClick={() =>
              navigate("/glucera" + GluceraNavigationRoutes.appdevicespage)
            }
            className="h-12 w-full rounded-2xl bg-gradient-primary text-base shadow-lg hover:opacity-90 sm:h-14 sm:text-lg"
          >
            Create My Plan
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
